import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/system";
import {
  DISPLAY_FLEX,
  FLEX_ALIGN_CENTER,
  FLEX_JUSTIFY_CENTER,
} from "../config/styles";
import { BulletCheckLogo } from "../assets/icons";
import { Typography } from "@mui/material";
import { colors } from "../config/colors";

const BulletTagStyled = styled("div")(() => ({
  width: "26px",
  height: "26px",
  borderRadius: "13px",
  border: "1px solid #ece6ff",
  display: DISPLAY_FLEX,
  justifyContent: FLEX_JUSTIFY_CENTER,
  alignContent: FLEX_ALIGN_CENTER,
  marginRight: "20px",
}));

export const BulletTag = ({ tag = "", disabled = false, isCheck = false }) => {
  const renderBackgroundColor = () => disabled ? colors.logoDisabled : colors.background
  return (
    <BulletTagStyled
      style={{
        backgroundColor: isCheck ? colors.primary : renderBackgroundColor(),
      }}
    >
      {isCheck ? (
        <span className="mt-1">
          <BulletCheckLogo />
        </span>
      ) : (
        <Typography
          variant="h4"
          component="label"
          sx={{
            color: disabled ? colors.grayLight : colors.primary,
            marginTop: "4px",
          }}
        >
          {tag}
        </Typography>
      )}
    </BulletTagStyled>
  );
};

BulletTag.propTypes = {
  tag: PropTypes.string,
  disabled: PropTypes.bool,
  isCheck: PropTypes.bool,
};
